import {
  CheckBox as CheckBoxIcon,
  Close as ResetIcon,
  Search as SearchIcon,
  CheckBoxOutlineBlank as UnCheckedBoxIcon,
} from "@mui/icons-material";
import { Box, Divider, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import MonthPicker from "../components/monthPicker/MonthPicker";
import { startOfPreviousMonth } from "../misc/dateUtils";

export interface CostSearchCriteria {
  text: string;
  month: Dayjs | null;
}

interface ShowPaidCheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

const ShowPaidCheckbox: FC<ShowPaidCheckboxProps> = ({ value, onChange }) => (
  <Tooltip title="Pokaż opłacone koszty">
    <IconButton color="inherit" onClick={() => onChange(!value)}>
      {value ? <CheckBoxIcon /> : <UnCheckedBoxIcon />}
    </IconButton>
  </Tooltip>
);

interface Props {
  search: CostSearchCriteria;
  onChange: (value: CostSearchCriteria) => void;
  showPaid: boolean;
  onShowPaidChange: (showPaid: boolean) => void;
}

const CostSearch: FC<Props> = ({ search, onChange, showPaid, onShowPaidChange }) => (
  <Stack
    direction="row"
    spacing={2}
    sx={{
      alignItems: "center",
    }}
  >
    <SearchIcon />
    <Box
      sx={{
        flexGrow: 3,
      }}
    >
      <TextField
        fullWidth
        value={search.text}
        label="Szukaj"
        onChange={(e) => onChange({ text: e.target.value, month: search.month })}
      />
    </Box>
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <MonthPicker value={search.month} onChange={(month) => onChange({ text: search.text, month })} />
    </Box>
    <IconButton color="inherit" onClick={() => onChange({ text: "", month: startOfPreviousMonth() })}>
      <ResetIcon />
    </IconButton>
    <Divider orientation="vertical" flexItem />
    <ShowPaidCheckbox value={showPaid} onChange={onShowPaidChange} />
  </Stack>
);

export default CostSearch;
